<template>
  <section class="behno_team_sec">
    <div class="container">
      <div class="sec_content">
        <h2 class="sec_heading" v-html="sanitizeHtml(shopifyData.secHeading)" />
        <div class="sec_tabs">
          <!-- <h2 class="sec_tabs_heading" v-for="(value, key) in shopifyData.tabmainheading"  :key="key">
                <template v-html="value.tabmainheading">
                </template>
          </h2> -->
          <div class="tab_wrapper">
            <div v-for="(value, key) in shopifyData.tabdata" :key="key" class="tab_inner">
              <h2 class="sec_tabs_heading" v-html="sanitizeHtml(value.tabmainheading)" />
              <div class="tab">
                <div class="tab_heading">
                  <h2 @click="openAccordian" v-html="sanitizeHtml(value.tabheading)" />
                  <span />
                </div>
                <div class="tab_content">
                  <div class="tab_content_inner">
                    <div class="tab_text">
                      <p v-html="sanitizeHtml(value.tabInfo)" />
                    </div>
                    <div class="tab_image">
                      <img
                        v-lazy="value.tabImage.src"
                        :src-placeholder="value.tabImage.placeholder"
                        :alt="value.tabImage.alt || 'Team Image'"
                        loading="lazy"
                        aria-hidden="true"
                        aria-label="Team Image"
                        width=""
                        height=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <p class="sec_info" v-html="sanitizeHtml(shopifyData.secinfo)" />
      </div>
    </div>
  </section>
</template>

<script>
import { sanitizeHtml } from '@/sanitizeContent.js';

export default {
  props: {
    shopifyData: {
      type: Object,
      required: true,
    },
  },
  data: () => {
    window.addEventListener('load', () => {
      const tab = document.querySelectorAll('.tab');

      const firstTabContent = tab[0].querySelector('.tab_content');
      const firstTabHeading = tab[0].querySelector('.tab_heading h2');
      const firstTabContentHeight = firstTabContent.scrollHeight;

      firstTabContent.setAttribute('style', `height:${firstTabContentHeight}px; opacity:1;`);
      tab[0].classList.add('show');
      firstTabHeading.classList.add('show');
    });
  },
  methods: {
    sanitizeHtml,
    openAccordian(event) {
      const parent = event.target.closest('.tab');
      const tabContent = parent.querySelector('.tab_content');
      const tabContentHeight = tabContent.scrollHeight;
      if (event.target.matches('.show')) {
        event.target.classList.remove('show');
        tabContent.removeAttribute('style');
        return;
      }
      event.target.classList.add('show');
      tabContent.setAttribute('style', `height:${tabContentHeight}px; opacity:1;`);
    },
  },
};
</script>

<style>
.tab_text p a {
  font-family: 'adobe-caslon-pro', sans-serif;
}

.tab_text p a:hover {
  text-decoration: underline;
}
</style>
<style scoped>
.container {
  max-width: 1440px;
  width: 100%;
  margin: 0 auto;
  padding: 0 10px;
}

.behno_team_sec {
  padding: 112px 0;
  background-color: #fff;
}

.sec_heading {
  font-family: 'Helvetica Neue', sans-serif;
  font-size: 26px;
  letter-spacing: 5px;
  font-weight: 600;
  line-height: 1.2;
  text-align: center;
  text-transform: uppercase;
}

.sec_info {
  font-size: 18px;
  line-height: 20px;
  font-family: 'adobe-caslon-pro', sans-serif;
  margin-top: 20px;
}

.tab {
  border: 1px solid #ddd;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
}

.sec_tabs_heading {
  font-family: 'Big Caslon', sans-serif;
  font-size: 72px;
  line-height: 68px;
  text-align: center;
  margin-bottom: 20px;
  font-weight: 500;
  margin-top: 45px;
}

.tab_heading h2 {
  font-size: 16px;
  line-height: 32px;
  padding: 10px;
  background: #f5f5f5;
  position: relative;
  cursor: pointer;
  transition: 0.3s;
  border-bottom: 1px solid transparent;
}

.tab_heading {
  position: relative;
}

.tab_heading h2.show {
  border-color: #ddd;
}

.tab_heading span {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  transform-origin: center center;
  transition: 0.3s;
}

.tab_heading span:after {
  content: '+';
  font-size: 20px;
  cursor: pointer;
  line-height: 0;
  transition: 0.3s;
}

.tab_heading h2.show + span {
  transform: translateY(-50%) rotate(135deg);
}

.tab_content {
  height: 0;
  padding: 0px;
  opacity: 0;
  overflow: hidden;
  transition: 0.3s linear;
}

.tab_content_inner {
  display: flex;
  align-items: stretch;
  gap: 30px;
  padding: 20px;
}

.tab_text {
  width: 50%;
  display: flex;
  align-items: center;
}

.tab_image {
  width: 50%;
}

.tab_image img {
  max-width: 350px;
  width: 100%;
  margin: 0 auto;
  display: block;
}

.tab_text p {
  font-size: 18px;
  line-height: 1;
  letter-spacing: 0.005em;
  font-family: 'adobe-caslon-pro', sans-serif;
}

.tab_wrapper .tab {
  margin-bottom: 20px;
}

.tab_wrapper .tab:last-child {
  margin-bottom: 0px;
}

/* Responsive css */

@media screen and (max-width: 767px) {
  .behno_team_sec {
    padding: 50px 0 80px;
  }

  .tab_content_inner {
    flex-direction: column;
  }

  .tab_content_inner > div {
    width: 100%;
  }

  .tab_heading h2 {
    padding-right: 35px !important;
  }
}
</style>
